import React, { useState, useMemo, useContext } from 'react';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const SingleReportFieldDetails = () => {
  const { fieldId } = useParams();
  const navigate = useNavigate();
  const decodedId = fieldId ? atob(fieldId) : fieldId;
  const id = decodedId.replace(/\D/g, '');
  const [showDelete, setShowDelete] = useState(false);
  const { showToast } = useContext(ToastContext);

  const url = id ? `${API_DOMAIN}${API_ROUTES['reportField']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'updated_at', 'created_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['reportField'] + id + '/', { headers });
      showToast('Report Field deleted successfully', 'success');
      navigate('/reporting/report-field/list');
    } catch (error) {
      console.error('Error deleting Report Field:', error);
      showToast('Error deleting Report Field', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Report Field"
        listPath="/reporting/report-field/list"
        editPath={`/reporting/report-field/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        show={showDelete}
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
        title="Delete Report Field"
        message="Are you sure you want to delete this Report Field?"
      />
    </div>
  );
};

export default SingleReportFieldDetails;
